import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  resultsContainer: {
    marginTop: theme.spacing(4),
    ...reskinStyles(theme, theme.cardStyles.highlight)
  }
});

export default makeStyles(styles);
